export const    THEME = 'THEME';
export const    THEME_SUCCESS = 'THEME_SUCCESS';
export const    THEME_ERROR = 'THEME_ERROR';

export const    ADD_THEME = 'ADD_THEME';
export const    ADD_THEME_SUCCESS = 'ADD_THEME_SUCCESS';
export const    ADD_THEME_ERROR = 'ADD_THEME_ERROR';

export const    UPDATE_THEME = 'UPDATE_THEME';
export const    UPDATE_THEME_SUCCESS = 'UPDATE_THEME_SUCCESS';
export const    UPDATE_THEME_ERROR = 'UPDATE_THEME_ERROR';

export const DELETE_THEME = 'DELETE_THEME';
export const DELETE_THEME_SUCCESS= 'DELETE_THEME_SUCCESS';
export const DELETE_THEME_ERROR ='DELETE_THEME_ERROR';